import { createSelector } from "reselect";
import { selectAccountState } from "../accountSelectors";
export const selectOrdersState = createSelector(selectAccountState, account => account.orders);
export const selectOrders = createSelector(selectOrdersState, orders => orders.list);
